import React from 'react';
import { browserHistory, Link } from 'react-router';

import request from 'services/request';

import Anchor from 'grommet/components/Anchor';
import Article from 'grommet/components/Article';
import LoginForm from 'grommet/components/LoginForm';

const ERRORS = {
  invalid_credentials: 'Incorrect username or password. Please try again',
}

export default class Login extends React.Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {};
  }

  componentWillMount() {
    if (localStorage.getItem('token')) {
      browserHistory.push('/admin');
    }
  }
  onSubmit({ username, password }) {
    this.setState({ error: '' });

    request({
      method: 'POST',
      url: '/api/login',
      body: {
        email: username,
        password,
      }
    })
      .then((res) => {
        localStorage.setItem('token', res.body.token);
        browserHistory.push('/admin')
      })
      .catch(res => {
        this.setState({ error: res.body.error });
      });

  }

  render() {
    return (
      <Article align="center" full justify="center">
        <LoginForm
          secondaryText={<span>Don't want to log in? <Anchor path="/">Go back</Anchor></span>}
          errors={[ERRORS[this.state.error]]}
          title="Log in"
          align="start"
          forgotPassword={<Link to="/forgot">Forgot password?</Link>}
          onSubmit={this.onSubmit}
         />
      </Article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js